import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseClient";
import "./login.css";

export default function Login() {
  const [form, setForm] = useState({
    loginId: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = form.loginId.trim();
    const password = form.password;

    if (!email || !password) {
      setMessage({
        type: "error",
        text: "يرجى إدخال البريد الإلكتروني وكلمة المرور.",
      });
      return;
    }

    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      const messages = {
        "auth/network-request-failed": "تعذر الاتصال. تحقق من الإنترنت.",
        "auth/too-many-requests": "محاولات كثيرة. يرجى المحاولة لاحقًا.",
        "auth/operation-not-allowed": "يرجى تفعيل تسجيل الدخول بالبريد الإلكتروني في Firebase.",
      };
      setMessage({ type: "error", text: messages[error.code] || "تعذر تسجيل الدخول. تحقق من البريد الإلكتروني وكلمة المرور وإعدادات Firebase." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginPage">
      <div className="loginShell">
        <section className="loginCard" aria-label="تسجيل الدخول">
          <div className="loginCardHeader">
            <div className="loginLogo">✓</div>
            <span className="loginEyebrow">بوابة الدخول</span>
            <h2 className="systemTitle">نِظَامُ مُتَابَعَةِ المَهَامِّ وَالأَعْمَالِ</h2>
            <p className="loginHint">يرجى إدخال بيانات الدخول للمتابعة إلى النظام</p>
          </div>

          <form className="loginForm" onSubmit={handleSubmit} autoComplete="off">
            <label>
              البريد الإلكتروني
              <input
                type="text"
                name="loginId"
                value={form.loginId}
                onChange={handleChange}
                placeholder="أدخل البريد الإلكتروني"
                autoComplete="username"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
              />
            </label>

            <label>
              كلمة المرور
              <div className="passwordWrap">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="اكتب كلمة المرور"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="togglePasswordBtn"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? "إخفاء" : "إظهار"}
                </button>
              </div>
            </label>

            {message.text ? (
              <div className={`messageBox ${message.type}`}>{message.text}</div>
            ) : null}

            <button type="submit" className="submitBtn" disabled={loading}>
              {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}
